import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';

import type { IFinancialDataResponse } from 'api/endpoints/useGetFinancialData';
import type { IResponse as IClientResponse } from 'api/endpoints/useGetClient';
import { WiseBadge } from 'components/wise';

import styles from 'theme/components/containers/TraderClientCardContainer/TraderClientFinance/TraderClientFinance.module.scss';

interface ITraderClientFinanseProps {
  data?: IFinancialDataResponse | null;
  client?: IClientResponse | null;
  isLoading?: boolean;
}

const TraderClientFinanse: React.FC<ITraderClientFinanseProps> = ({ data, client, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div
        className={classnames(
          styles.wrapper,
          'StylePath-Containers-TraderClientCardContainer-TraderClientFinanse'
        )}>
        <section className={styles.section}>
          <Skeleton variant="text" width={80} height={24} sx={{ mb: 1.5 }} />
          <Skeleton variant="text" width="70%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="60%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="50%" height={20} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="65%" height={20} />
        </section>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <div
      className={classnames(
        styles.wrapper,
        'StylePath-Containers-TraderClientCardContainer-TraderClientFinanse'
      )}>
      <section className={styles.section}>
        <div style={{ display: 'flex', gap: 8 }}>
          <h3 className={styles.sectionTitle}>{t('Finanse')}</h3>
          {data.is_blocked && <WiseBadge variant="blocked" size="small" />}
        </div>
        <p className={styles.row}>
          <span className={styles.label}>{t('Limit kredytowy')}:</span>{' '}
          <span className={styles.value}>{client?.trade_credit_free ? client?.trade_credit_free.toFixed(2) : '–'}</span>
        </p>
        <p className={styles.row}>
          <span className={styles.label}>{t('Pozostało')}:</span>{' '}
          <span className={styles.value}>{client?.trade_credit_total ? client?.trade_credit_total.toFixed(2) : '–'}</span>
        </p>
        <p className={styles.row}>
          <span className={styles.label}>{t('Termin płatności')}:</span>{' '}
          <span className={styles.value}>{data.payment_due ?? '–'}</span>
        </p>
        <p className={styles.row}>
          <span className={styles.label}>{t('Należności po terminie')}:</span>{' '}
          <span className={classnames(styles.value, { [styles.orange]: data.receivables_overdue })}>
            {data.receivables_overdue ?? '–'}
          </span>
        </p>
      </section>
    </div>
  );
};

export default TraderClientFinanse;
